import { once } from "lodash-es";
import React from "react";
import { connect } from "react-redux";
import { createToolbarEvent } from "../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../analytics/functions";
import { leaveConference } from "../../base/conference/actions";
import { translate } from "../../base/i18n/functions";
import AbstractHangupButton from "../../base/toolbox/components/AbstractHangupButton";
import { ensureDeviceId } from "../../auth/functions";
import { authApi } from "../../auth/api";
import { setLeavingOverlay } from "../actions.web";
/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class HangupButton extends AbstractHangupButton {
    _hangup;
    accessibilityLabel = "toolbar.accessibilityLabel.hangup";
    label = "toolbar.hangup";
    tooltip = "toolbar.hangup";
    /**
     * Initializes a new HangupButton instance.
     *
     * @param {Props} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            isClicked: false
        };
        this._hangup = once(async () => {
            this.setState({ isClicked: true });
            this.props.dispatch(setLeavingOverlay(true));
            const roomName = window.location.pathname.slice(1).toLowerCase();
            const deviceId = ensureDeviceId();
            // فوراً کنفرانس رو ترک می‌کنیم
            sendAnalytics(createToolbarEvent("hangup"));
            this.props.dispatch(leaveConference());
            // بعد API رو صدا می‌زنیم (fire and forget)
            authApi.exitRoom(roomName, deviceId).catch((e) => {
                console.warn("exitRoom API failed", e);
            });
        });
    }
    /**
     * Helper function to perform the actual hangup action.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _doHangup() {
        this._hangup();
    }
    /**
     * Gets the custom class based on state.
     *
     * @returns {string} The custom class.
     */
    _getCustomClass() {
        const baseClass = this.props.customClass || '';
        return this.state.isClicked
            ? `${baseClass} hangup-button--clicked`.trim()
            : baseClass;
    }
    /**
     * Renders the button.
     *
     * @returns {ReactElement}
     */
    render() {
        const element = super.render();
        if (React.isValidElement(element)) {
            return React.cloneElement(element, {
                // @ts-ignore
                customClass: this._getCustomClass()
            });
        }
        return element;
    }
}
export default translate(connect()(HangupButton));
